import { DropdownSort, pxToRem } from '@archipro-design/aria';

import { Link, useLocation } from 'react-router';
import { CustomCaretDown, CustomCaretUp } from '@archipro-design/icons';

import {
    SORT_OPTIONS,
    SORT_DEFAULT_INDEX,
    SORT_PLACEHOLDER_LABEL,
} from '@modules/professional/component/video-tab/util';
import type { VideoSortProps } from './VideoSort';
import { PROFESSIONAL_SECTIONS_ANCHOR } from '../../util/constants';

const VideoSortDesktop: React.FC<VideoSortProps> = ({ initialSort }) => {
    const location = useLocation();

    const sortOptions = SORT_OPTIONS.map((i, idx) => {
        const sortParams = new URLSearchParams({
            page: '1',
            ...(i?.param && { sortBy: i.param.toString() }),
        });

        return {
            as: Link,
            to: `${location.pathname}?${sortParams.toString()}#${PROFESSIONAL_SECTIONS_ANCHOR}`,
            header:
                idx === SORT_DEFAULT_INDEX ? SORT_PLACEHOLDER_LABEL : i.item,
        };
    });

    return (
        <DropdownSort
            checkable={true}
            renderItem={(Component, componentProps) => {
                if (componentProps.header === SORT_PLACEHOLDER_LABEL)
                    componentProps.header =
                        SORT_OPTIONS[SORT_DEFAULT_INDEX].item;

                return <Component {...componentProps} />;
            }}
            defaultValue={sortOptions[0]}
            value={sortOptions[initialSort]}
            items={sortOptions}
            placeholder={SORT_PLACEHOLDER_LABEL}
            expandIcon={<CustomCaretUp />}
            collapseIcon={<CustomCaretDown />}
            variables={{
                primaryDropdownFontSize: pxToRem(18),
                dropdownItemFontSize: pxToRem(18),
                checkIconWidth: pxToRem(16),
                checkIconHeight: pxToRem(16),
                iconLabelGap: '0',
            }}
            styles={{
                fontWeight: 500,
            }}
        />
    );
};

export default VideoSortDesktop;
